module.exports = __webpack_public_path__ + "static/img/contant_4.0aaf58d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_12/contant_4.jpg
// module id = z16i
// module chunks = 0